import type { LocationPublic } from '@repo/types/locations';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { LocationKey } from './keys';
import { LocationService } from './locationService';

export function useDeleteLocation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => LocationService.deleteLocation(id).then((response) => response.data),
    onMutate: async (id: number) => {
      await queryClient.cancelQueries({ queryKey: [LocationKey.LOCATIONS] });

      const previousLocations = queryClient.getQueryData<LocationPublic[]>([LocationKey.LOCATIONS]);

      queryClient.setQueryData([LocationKey.LOCATIONS], (prev: LocationPublic[] | undefined) => {
        if (!prev) {
          return [];
        }
        return prev.filter((location: LocationPublic) => location.id !== id);
      });

      return { previousLocations };
    },
    onError: (_error, _id, context) => {
      if (context?.previousLocations) {
        queryClient.setQueryData([LocationKey.LOCATIONS], context.previousLocations);
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [LocationKey.LOCATIONS] });
    },
  });
}
